import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AdminApp } from './admin/AdminApp.js'
import { EnrollApp } from './enroll/EnrollApp.js'
import { OwnerApp } from './owner/OwnerApp.js'
import { StaffApp } from './staff/StaffApp.js'

/**
 * Top-level router. Three sub-applications, each owning its own QueryClient,
 * theme scope, and toast surface:
 *   /admin/*  → AdminApp  (superadmin — slices 3a/3b/3c)
 *   /staff/*  → StaffApp  (staff login + placeholder — slice 4a-1)
 *   /e/*      → EnrollApp (public customer enrollment — slice 4a-4b)
 *   /*        → OwnerApp  (owner login, setup wizard, dashboard, branding)
 *
 * OwnerApp is the catch-all: it owns `/login`, `/setup/*`, `/dashboard`,
 * `/branding`, and the root redirect.
 */
export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/staff/*" element={<StaffApp />} />
        <Route path="/e/*" element={<EnrollApp />} />
        <Route path="/*" element={<OwnerApp />} />
      </Routes>
    </BrowserRouter>
  )
}
